module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "Pos");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=Pos!./src/pages/Pos/Device/index.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=Pos!./src/pages/Pos/Device/index.js
// module chunks = 43